// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICensusReportErrorDetailsDto } from './ICensusReportErrorDetailsDto';
import {
    ICensusReportErrorDetailsDtoFromJSON,
    ICensusReportErrorDetailsDtoFromJSONTyped,
    ICensusReportErrorDetailsDtoToJSON,
    ICensusReportErrorDetailsDtoToJSONTyped,
} from './ICensusReportErrorDetailsDto';

/**
 * 
 * @export
 * @interface ICensusReportDto
 */
export interface ICensusReportDto {
    /**
     * 
     * @type {number}
     * @memberof ICensusReportDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICensusReportDto
     */
    status?: ICensusReportDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICensusReportDto
     */
    message?: string;
    /**
     * 
     * @type {Array<ICensusReportErrorDetailsDto>}
     * @memberof ICensusReportDto
     */
    error_details?: Array<ICensusReportErrorDetailsDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICensusReportDtoStatusEnum {
    SUCCEED = 'SUCCEED',
    FAILURE = 'FAILURE'
}


/**
 * Check if a given object implements the ICensusReportDto interface.
 */
export function instanceOfICensusReportDto(value: object): value is ICensusReportDto {
    return true;
}

export function ICensusReportDtoFromJSON(json: any): ICensusReportDto {
    return ICensusReportDtoFromJSONTyped(json, false);
}

export function ICensusReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'error_details': json['errorDetails'] == null ? undefined : ((json['errorDetails'] as Array<any>).map(ICensusReportErrorDetailsDtoFromJSON)),
    };
}

export function ICensusReportDtoToJSON(json: any): ICensusReportDto {
    return ICensusReportDtoToJSONTyped(json, false);
}

export function ICensusReportDtoToJSONTyped(value?: ICensusReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'message': value['message'],
        'errorDetails': value['error_details'] == null ? undefined : ((value['error_details'] as Array<any>).map(ICensusReportErrorDetailsDtoToJSON)),
    };
}

